import {
    getConsolidatedTipsExport,
    getDirectExport,
    getOutSourcedExport
} from '@/services/siesa-report/service'

const state = () => ({
    exportList: [],
    errors: []
})

const mutations = {
    SET_DATA (state, data = []) {
        state.exportList = data
    },
    SET_ERROR (state, errors = []) {
        state.errors = errors
    }
}
const actions = {
    async outSourcedExport ({ commit }, date = '') {
        const { success, result , error } = await getOutSourcedExport(date)
        if (error) { commit("SET_ERROR", error.detail) }
        if (success) {
            commit("SET_ERROR")
            commit("SET_DATA", result)
        }
    },
    async directExport({ commit }, date = '') {
        const { success, result , error } = await getDirectExport(date)
        if (error) { commit("SET_ERROR", error.detail) }
        if (success) {
            commit("SET_ERROR")
            commit("SET_DATA", result)
        }
    },
    async consolidatedTipsExport({ commit }, date = '') {
        const { success, result , error } = await getConsolidatedTipsExport(date)
        if (error) { commit("SET_ERROR", error.detail) }
        if (success) {
            commit("SET_ERROR")
            commit("SET_DATA", result)
        }
    }
}
const getters = {
    getExportList: (state) => {
        return state.exportList
    },
    getErrors: (state) => {
        return state.errors
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}


